var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"noData"},[_c('div',{staticClass:"svgBox"},[_c('svg-icon',{staticClass:"noData_svg",attrs:{"iconClass":"noData"}}),_c('p',{staticClass:"desc"},[_vm._v(_vm._s(_vm.description))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }